<template>
  <div>
    <page-head :title="title" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="不动产单元号" prop="estateUnitNO">
                <Input v-model="query.estateUnitNO" clearable placeholder="请输入不动产单元号" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="缴费人" prop="userName">
                <Input v-model="query.userName" clearable placeholder="请输入缴费人" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="证件号码" prop="idCardNO">
                <Input v-model="query.idCardNO" clearable placeholder="请输入证件号码" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="采集人" prop="createUserName">
                <Input v-model="query.createUserName" clearable placeholder="请输入采集人" />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="审核状态" prop="checkStatus">
                <Select v-model="query.checkStatus" clearable>
                  <Option
                    v-for="item in typeList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="使用状态" prop="useStatus">
                <Select v-model="query.useStatus" clearable>
                  <Option
                    v-for="item in useList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-row-dblclick="handleClickDetail1"
          @on-selection-change="handleSelect"
        >
          <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row, 'detail')" class="action">[详情]</span>
            <span @click="handleClickDetail(row, 'pass')" class="action">[审核通过]</span>
            <span @click="handleClickDetail(row, 'fail')" class="action">[审核不通过]</span>
              <Poptip
              confirm
              title="确认删除?"
              placement="left"
              @on-ok="handleClickDetail(row, 'del')"
            >
              <span class="action">[删除]</span>
            </Poptip>
          </template>
          <template slot-scope="{ row, index }" slot="view">
            <span @click.stop="clickPic(row)">[查看]</span>
          </template>
        </i-table>
        <preview-img
          :currentIndex="0"
          :imgArr="showPreview.list"
          v-if="showPreview.show"
          v-on:closePreview="closePreview"
        ></preview-img>
        <div class="page">
          <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
        </div>
      </div>
    </div>
    <Modal
      @on-visible-change="onVisibleChange"
      :value="showCheckMsg"
      :title="modalTitle"
      :width="550"
    >
      <div v-if="estateUnitNO" class="estateTitle">
        审核的不动产单元号：
        <row>
          <i-col span="12">
            <div class="estateNO">{{estateUnitNO}}</div>
          </i-col>
        </row>
      </div>
      <template v-else>
        <div class="estateTitle">审核的不动产单元号：</div>
        <row>
          <template :gutter="0" v-for="item in estateUnitNOList">
            <i-col span="12">
              <div class="estateNO">{{item}}</div>
            </i-col>
          </template>
        </row>
      </template>
      <br />
      <Input type="textarea" v-model="checkMsg" :rows="10" placeholder="请输入..." />
      <div slot="footer">
        <Button style="margin-right:10px" @click="showCheckMsg = false">取消</Button>
        <Button type="primary" @click="review" :loading="isBtbLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>



<script>
import pageHead from "../../../../components/head";
import PreviewImg from "../../../../components/previewImg";
import api from "../../../../api/index";
const {
  dataCollectionList,
  batchCheckLandTransfer,
  dataCollectionExport,
  deleteCollectionBatch
} = api;
const TYPEMAP = {
  0: {
    checkStatus: "审核未通过",
  },
  1: {
    checkStatus: "审核已通过",
  },
  2: {
    checkStatus: "待审核",
  },
};
const STATUSMAP = {
  0: {
    useStatus: "未使用",
  },
  1: {
    useStatus: "已使用",
  },
};
export default {
  name: "priceDifference",
  components: {
    pageHead,
    PreviewImg,
  },

  data() {
    return {
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      showPreview: {
        show: 0,
        list: [],
      }, //预览图片
      typeList: [
        {
          index: 0,
          type: "未通过",
        },
        {
          index: 1,
          type: "已通过",
        },
        {
          index: 2,
          type: "待审核",
        },
      ],
      useList: [
        {
          index: 0,
          type: "未使用",
        },
        {
          index: 1,
          type: "已使用",
        },
      ],
      query: {
        estateUnitNO: "",
        checkStatus: "",
        useStatus: "",
        userName: "",
        idCardNO: "",
        createUserName: "",
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "差价补缴采集",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "搜索",
          type: "search",
        },
        {
          name: "审核通过",
          type: "checkPass",
        },
        {
          name: "审核不通过",
          type: "checkFail",
        },
        {
          name: "批量删除",
          type: "delBatch",
        },
        {
          name: "导出",
          type: "export",
        },
      ],
      tableHeader: [
        {
          type: "selection",
          width: 70,
          align: "center",
        },
        {
          title: "不动产单元号",
          key: "estateUnitNO",
        },
        {
          title: "缴费人",
          key: "userName",
        },
        {
          title: "证件号码",
          key: "idCardNO",
        },
        {
          title: "采集人",
          key: "createUserName",
        },
        {
          title: "采集时间",
          key: "createTime",
        },
        {
          title: "审核状态",
          key: "checkStatus",
        },
        {
          title: "使用状态",
          key: "useStatus",
        },
        {
          title: "凭证",
          slot: "view",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      selectedList: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.pageNum = 1;
        this.query.checkStatus = "";
        this.query.useStatus = "";
        this.$refs.search.resetFields();
        this.getLandTransferList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getLandTransferList();
      } else if (type == "checkPass") {
        console.log("checkPass");
        if (this.selectedList.length == 0) {
          return this.$Message.warning("请选择要审核的项目");
        }
        (this.checkMsg = "审核通过"), (this.status = 1);
        this.modalTitle = "审核通过说明(选填)";
        this.showCheckMsg = true;
      } else if (type == "checkFail") {
        console.log("checkFail");
        if (this.selectedList.length == 0) {
          return this.$Message.warning("请选择要审核的项目");
        }
        this.status = 0;
        this.modalTitle = "审核未通过说明(必填)";
        this.showCheckMsg = true;
      } else if (type == "delBatch") {
        if (this.selectedList.length == 0) {
          return this.$Message.warning("请选择要删除的项目");
        }
        // console.log(this.selectedList.join(','));
        this.$Modal.confirm({
          title: "删除",
          content: "是否确认删除",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.handleDelete(this.selectedList.join(","));
          },
        });
      } else if (type == "export") {
        let {
          estateUnitNO,
          userName,
          idCardNO,
          checkStatus,
          useStatus,
        } = this.query;
        checkStatus = checkStatus ? checkStatus : "";
        useStatus = useStatus ? useStatus : "";
        let url =
          dataCollectionExport +
          "?infoType=4" +
          "&estateUnitNO=" +
          estateUnitNO +
          "&checkStatus=" +
          checkStatus +
          "&userName=" +
          userName +
          "&idCardNO=" +
          idCardNO +
          "&useStatus=" +
          useStatus +
          "&token=" +
          this.header.token;
        console.log(url);
        window.open(url);
      }
    },
    onVisibleChange(val) {
      if (!val) {
        this.showCheckMsg = false;
        this.checkMsg = "";
      }
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.show = 0;
    },
    clickPic(val) {
      this.showPreview.list = [];
      console.log(val);
      val.picArr.length > 0 &&
        val.picArr.forEach((item) => {
          this.showPreview.list.push({ isHeight: true, path: item });
        });
      console.log(this.showPreview.list);
      this.showPreview.show = 1;
    },
    handleSelect(selection) {
      this.selectedList = [];
      this.estateUnitNOList = [];
      this.estateUnitNO = "";
      selection.forEach((item) => {
        this.selectedList.push(item.id);
        this.estateUnitNOList.push(
          item.estateUnitNO.replace(/(\d{6})(\d{6})(\w{7})/g, "$1 $2 $3 ")
        );
      });
      console.log(this.selectedList);
    },
    async review() {
      if (!this.checkMsg) {
        return this.$Message.info("请填写审核说明");
      }
      this.isBtbLoading = true;
      try {
        let ids = this.checkedId ? [this.checkedId] : this.selectedList;
        console.log(ids);
        let res = await this.$post(batchCheckLandTransfer, {
          checkStatus: this.status,
          checkMsg: this.checkMsg,
          ids: ids.join(","),
        });
        this.showCheckMsg = false;
        this.$Message.info("操作成功");
        this.getLandTransferList();
      } finally {
        this.isBtbLoading = false;
        this.checkedId = "";
      }
    },
    cancelModal() {},
    handleClickDetail1(item) {
      this.$router.push({
        name: "priceDifferenceDetail",
        query: { estateCollectionId: item.id },
      });
    },
    async handleDelete(id) {
      let res = await this.$delete(deleteCollectionBatch, {
        idList: id,
      });
      if (res.isSucceed) {
        this.$Message.success("删除成功");
        this.getLandTransferList();
      }
    },
    handleClickDetail(item, type) {
      console.log(item, type);
      if (type == "detail") {
        this.$router.push({
          name: "priceDifferenceDetail",
          query: { estateCollectionId: item.id },
        });
      } else if (type == "del") {
        console.log("del", item.id);
        this.handleDelete(item.id);
      } else {
        if (type == "pass") {
          this.modalTitle = "审核通过说明(选填)";
          (this.checkMsg = "审核通过"), (this.status = 1);
        } else {
          this.modalTitle = "审核未通过说明(必填)";
          this.status = 0;
        }
        this.estateUnitNO = item.estateUnitNO.replace(
          /(\d{6})(\d{6})(\w{7})/g,
          "$1 $2 $3 "
        );
        this.checkedId = item.id;
        this.showCheckMsg = true;
      }
    },
    pageChange(val) {
      this.pageNum = val;
      this.getLandTransferList();
    },
    async getLandTransferList() {
      this.isLoading = true;
      try {
        let res = await this.$get(dataCollectionList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          infoType: 4,
          communityId: this.$store.state.streetorcommunityid,
          ...this.query,
        });
        console.log(this.query);

        let list = res.rows.map((item) => ({
          ...item,
          ...TYPEMAP[item.checkStatus != null ? +item.checkStatus : null],
          ...STATUSMAP[item.useStatus != null ? +item.useStatus : null],
          userName: item.userList[0] && item.userList[0].userName,
          idCardNO: item.userList[0] && item.userList[0].idCardNO,
          picArr: item.picUrl && item.picUrl.split(","),
        }));
        console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getLandTransferList();
    console.log(this.$route);
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}

.statistics {
  padding: 10px 0;
  text-align: right;
}

.estateTitle {
  color: #ff7b44;
  font-weight: bold;
}

.estateNO {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}
</style>